import clsx from 'clsx';
import { CloudOff, CloudUpload, RefreshCw, TriangleAlert, Wifi } from 'lucide-react';
import { navigate } from '../lib/router';
import { useSyncState } from '../lib/sync';
import { useUpdateState } from '../lib/service-worker';

/**
 * Лентата за състоянието. Шофьорът трябва да може да отговори на въпроса
 * „изпрати ли се?" с един поглед, без да пита диспечера.
 */
export function StatusBar() {
  const { online, running, pending, blocked } = useSyncState();

  const tone = blocked > 0 ? 'stop' : pending > 0 ? 'warn' : online ? 'go' : 'plain';
  const label = blocked
    ? `${blocked} записа с грешка`
    : pending > 0
      ? `${pending} чакат изпращане`
      : online
        ? 'Всичко е изпратено'
        : 'Без връзка — всичко се пази';

  const tones: Record<string, string> = {
    go: 'bg-go/10 text-go border-go',
    warn: 'bg-warn/10 text-warn border-warn',
    stop: 'bg-stop/10 text-stop border-stop',
    plain: 'bg-card text-muted border-line',
  };

  return (
    <button
      type="button"
      onClick={() => navigate('/queue')}
      className={clsx(
        'flex w-full items-center gap-2 border-b-2 px-3 py-2 text-left text-base font-semibold',
        tones[tone],
      )}
      style={{ minHeight: 44 }}
    >
      {blocked > 0 ? (
        <TriangleAlert size={22} />
      ) : running ? (
        <RefreshCw size={22} className="animate-spin" />
      ) : online ? (
        pending > 0 ? (
          <CloudUpload size={22} />
        ) : (
          <Wifi size={22} />
        )
      ) : (
        <CloudOff size={22} />
      )}
      <span className="flex-1 truncate">{label}</span>
      <span className="opacity-70">подробно</span>
    </button>
  );
}

/** Лента за нова версия. Не се обновява само — шофьорът решава кога. */
export function UpdateBanner() {
  const { updateReady, applyUpdate } = useUpdateState();
  if (!updateReady) return null;
  return (
    <div className="flex items-center gap-3 border-b-2 border-brand bg-brand px-3 py-3 text-[color:var(--app-brand-ink)]">
      <span className="flex-1 text-lg font-bold">Има нова версия на приложението</span>
      <button
        type="button"
        onClick={applyUpdate}
        className="rounded-xl bg-[color:var(--app-brand-ink)] px-4 py-3 text-lg font-bold text-brand"
      >
        Презареди
      </button>
    </div>
  );
}
